import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './RestaurantHomeSkeleton.css';

const RestaurantHomeSkeleton: React.FC = () => {
  return (
    <div className="rd-page rd-page--skeleton">
      <Header />
      <div className="rd-skel-hero" />
      <div className="rd-skel-stats">
        {[1, 2, 3].map((i) => (
          <div key={i} className="rd-skel-stat" />
        ))}
      </div>

      <div className="rd-skel-catalog-section">
        <div className="rd-skel-catalog-title" />
        <div className="rd-skel-cuisine-track">
          <div className="rd-skel-cuisine-banner" />
          <div className="rd-skel-cuisine-banner rd-skel-cuisine-banner--peek" aria-hidden />
        </div>
      </div>

      <div className="rd-skel-catalog-section">
        <div className="rd-skel-catalog-title" />
        <div className="rd-skel-category-track">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="rd-skel-category-card" />
          ))}
        </div>
      </div>

      <div className="rd-skel-order-strip">
        <div className="rd-skel-order-title" />
        <div className="rd-skel-order-grid">
          {[1, 2, 3].map((i) => (
            <div key={i} className="rd-skel-order-card" />
          ))}
        </div>
      </div>

      <div className="rd-skel-body">
        <div className="rd-skel-col">
          <div className="rd-skel-card" />
          <div className="rd-skel-card rd-skel-card--tall" />
        </div>
        <div className="rd-skel-col rd-skel-col--side">
          <div className="rd-skel-card" />
          <div className="rd-skel-card" />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RestaurantHomeSkeleton;
